namespace Roodik.Core
{
	export class LocalizationManager
	{
		private _cache:Array<string> = new Array<string>();

		constructor(private _provider:ILanguage)
		{
			console.log("_provider = ",_provider);
		}

		public getString(id:string):string
		{
			if (this._cache[id] != null) return this._cache[id];

			for (let i:number = 0; i < this._provider.data.length; i++)
			{
				let key = this._provider.data[i].key;
				let value = this._provider.data[i].value;

				if (this._cache[key] == null)
				{
					this._cache[key] = value;
				}

				if (id == key)
				{
					return value;
				}
			}
			return "undefined";
		}

		public get locale():string { return this._provider.locale; }
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Localization/LocalizationManager.ts